module.exports = __webpack_public_path__ + "static/media/f_faceshape_round_vector.8b28599c.svg";